import { actionCreator } from "../../helpers/redux/actionCreator";
import * as ActionTypes from "./types";

export const setCartMessage = actionCreator(ActionTypes.SET_CART_MESSAGE);

export const getCart = actionCreator(ActionTypes.CART_GET);
export const getCartSucceeded = actionCreator(ActionTypes.CART_GET_SUCCEEDED);
export const getCartFailed = actionCreator(ActionTypes.CART_GET_FAILED);

export const editCart = actionCreator(ActionTypes.CART_EDIT);
export const editCartSucceeded = actionCreator(ActionTypes.CART_EDIT_SUCCEEDED);
export const editCartFailed = actionCreator(ActionTypes.CART_EDIT_FAILED);

export const clearLastAdded = actionCreator(ActionTypes.CART_CLEAR_LAST_ADDED);
export const clearCart = actionCreator(ActionTypes.CART_CLEAR_CART);
export const ackCartRefresh = actionCreator(ActionTypes.CART_ACK_REFRESH);